import React from 'react';
import { Documents } from 'components/documents/Documents';
import { DocumentsItem } from 'components/documents/DocumentsItem';
import { Divider } from 'components/elements/divider/Divider';
import { Documents as NewDocuments } from '@alvogen/shared/components/documents/Documents';
import { Tabs } from '@alvogen/shared/components/tabs/Tabs';

export const Component = () => {
  return (
    <>
      <Divider>Simple</Divider>

      <Documents isSlice>
        <DocumentsItem
          filename="Very long file name lorem ipsum dolor sit amet constetur amet lorem dolor"
          link={{ href: 'https://kodo.is' }}
          filesize={1000000}
        />
        <DocumentsItem
          filename="Very long file name lorem ipsum dolor sit amet constetur amet lorem dolor"
          link={{ href: 'https://kodo.is' }}
          filesize={1000000}
        />
        <DocumentsItem
          filename="File name lorem ipsum dolor"
          link={{ href: 'https://kodo.is' }}
          filesize={1000000}
        />
        <DocumentsItem
          filename="File name lorem ipsum dolor"
          link={{ href: 'https://kodo.is' }}
          filesize={1000000}
        />
        <DocumentsItem
          filename="File name lorem ipsum dolor"
          link={{ href: 'https://kodo.is' }}
          filesize={1000000}
        />
        <DocumentsItem
          filename="File name lorem ipsum dolor"
          link={{ href: 'https://kodo.is' }}
          filesize={1000000}
        />
        <DocumentsItem
          filename="File name lorem ipsum dolor"
          link={{ href: 'https://kodo.is' }}
          filesize={1000000}
        />
      </Documents>

      <Divider>Extended</Divider>

      <NewDocuments>
        <NewDocuments.Item title="File name lorem ipsum dolor" link={{ href: 'https://kodo.is' }} />
        <NewDocuments.Item title="File name lorem ipsum dolor" link={{ href: 'https://kodo.is' }} />
        <NewDocuments.Item title="File name lorem ipsum dolor" link={{ href: 'https://kodo.is' }} />
      </NewDocuments>

      <Divider>Grouped extended</Divider>

      <Tabs
        title="Documents"
        tabs={[
          {
            title: 'Documents 1',
            content: (
              <NewDocuments tab>
                <NewDocuments.Item
                  title="File name lorem ipsum dolor"
                  link={{ href: 'https://kodo.is' }}
                />
                <NewDocuments.Item
                  title="File name lorem ipsum dolor"
                  link={{ href: 'https://kodo.is' }}
                />
                <NewDocuments.Item
                  title="File name lorem ipsum dolor"
                  link={{ href: 'https://kodo.is' }}
                />
              </NewDocuments>
            ),
          },
          {
            title: 'Documents 2',
            content: (
              <NewDocuments tab>
                <NewDocuments.Item
                  title="File name lorem ipsum dolor"
                  link={{ href: 'https://kodo.is' }}
                />
                <NewDocuments.Item
                  title="File name lorem ipsum dolor"
                  link={{ href: 'https://kodo.is' }}
                />
                <NewDocuments.Item
                  title="File name lorem ipsum dolor"
                  link={{ href: 'https://kodo.is' }}
                />
              </NewDocuments>
            ),
          },
          {
            title: 'Documents 3',
            content: (
              <NewDocuments tab>
                <NewDocuments.Item
                  title="File name lorem ipsum dolor"
                  link={{ href: 'https://kodo.is' }}
                />
                <NewDocuments.Item
                  title="File name lorem ipsum dolor"
                  link={{ href: 'https://kodo.is' }}
                />
                <NewDocuments.Item
                  title="File name lorem ipsum dolor"
                  link={{ href: 'https://kodo.is' }}
                />
              </NewDocuments>
            ),
          },
        ]}
      />
    </>
  );
};
